// import { useCallback, useEffect } from "react";

// export const useDebouncedEffect = (effect, delay, deps) => {
//   const callback = useCallback(effect, deps);

//   useEffect(
//     () => {
//       const handler = setTimeout(() => {
//         callback();
//       }, delay);

//       return () => {
//         clearTimeout(handler);
//       };
//     },
//     [callback, delay]
//   );
// };

import { useCallback, useEffect } from "react";

function useDebouncedEffect(fn, deps, delay) {
  const callback = useCallback(fn, deps);
  useEffect(
    () => {
      const timeout = setTimeout(fn, delay);
      return () => {
        clearTimeout(timeout);
      };
    },
    [callback, delay]
  );
}

export { useDebouncedEffect };
